<template>
  <div class="commission">
    <van-sticky>
      <van-nav-bar title="分销佣金" left-arrow @click-left="goback()" />
    </van-sticky>
    <div class="commission_top">
      <div class="fs30">{{detail.totalCash}}</div>
      <div class="fs11">累计提成(元)</div>
    </div>
   <!--  (提现后24小时内到账，请协助(汽车医生)上传图片才能提现审核成功) -->
    <van-cell class="commission_s" title="可提现提成" icon="balance-o">
      <template #right-icon>
        <div class="s">{{detail.canCash}}元</div>
      </template>
    </van-cell>
    <van-cell title="已申请提成" icon="clock-o">
      <template #right-icon>
        <div>{{detail.appliedCash}}元</div>
      </template>
    </van-cell>
    <van-cell title="待打款提成" icon="after-sale">
      <template #right-icon>
        <div>{{detail.waitCash}}元</div>
      </template>
    </van-cell>
    <van-cell title="无效提成" icon="refund-o">
      <template #right-icon>
        <div>{{detail.rejectCash}}元</div>
      </template>
    </van-cell>
    <van-cell title="成功提现提成" icon="pending-payment">
      <template #right-icon>
        <div>{{detail.alreadyCash}}元</div>
      </template>
    </van-cell>
  </div>
</template>
<script>
import { Button, NavBar, Icon, Sticky, Cell } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Cell.name]: Cell
  },
  data() {
    return {
      detail: {
        "totalCash": 0,
        "canCash": 0,
        "appliedCash": 0,
        "waitCash": 0,
        "rejectCash": 0,
        "alreadyCash": 0
      },
      userInfo:"",
    };
  },
  mounted(){
    this.getCashInfo();
    this.getUserInfo();
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    //跳转立即租赁
    toSiteLease() {
      this.$router.push({ path: "/home/siteLease" });
    },

    //跳转立即预约
    toSiteSubscribe() {
      this.$router.push({ path: "/home/siteSubscribe" });
    },

    //获取分销佣金
    getCashInfo() {
      let that = this;
      that.$api.userH5ApplyCashAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.detail = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //获取分销用户信息
    getUserInfo() {
      let that = this;
      that.$api.distributorIndexAPI("").then(function(res) {
        if (res.data.code == 200) {
          that.userInfo = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },
  }
};

</script>
<style lang="less" scoped>
.commission {
  .commission_top {
    background: #fca33d;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0px;
    flex-direction: column;
  }

  .van-cell {
    align-items: center;
  }

  .commission_s {
    border-top: 20px solid #f1f2f1;
    border-bottom: 20px solid #f1f2f1;

    .s {
      color: #fca33d;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/distribution/commission.vue